module.exports = __webpack_public_path__ + "static/gallery_treehouse_6-914dd8d18ecd23eed0256708ffff55fa.jpg";